<template>
  <div class="textpage">
      <div class="main-content">
        <h1 v-html="post.title"></h1>
        <div class="cms-content" v-html="post.content"></div>
    </div>
  </div>
</template>

<script>

const ENDPOINT_NAME = 'ppw/v1/post'
const axios = require('axios');

export default {
  name: "paginaContent",
  data() {
    return {
      post: Array,
    }
   },

  components: {
  },  

  methods: {

    getPosts() {
      let postid = this.$route.params.p
      this.template = 'post-'+postid      
      const url = new URL(process.env.VUE_APP_REST_URL + ENDPOINT_NAME + '?p='+postid)

      axios.get(url)
        .then((response) => {
          this.post = response.data
        })
        .catch( (error) => {
          console.log(error)
        });
    },

  },

  computed: {
  },
  
  created() {
    setTimeout(() => this.getPosts(), 50);
  },

  mounted() {    
  }
};

</script>

